import { AbstractValidatedClass, Joi, ValidatedClass, constraint } from '@verclam/form-validator';

type EmailFormArgs = {
	email: string;
};

/** Step 1 of the login screen: the address alone, used to resolve the authentication modes. */
@ValidatedClass()
class EmailFormData extends AbstractValidatedClass<EmailFormArgs> {
	@constraint(Joi.string().email({ tlds: false }), () => 'L’adresse e-mail est invalide')
	@constraint(Joi.string().required(), () => 'L’adresse e-mail est obligatoire')
	public readonly email: string;

	constructor(data: EmailFormArgs) {
		super(data);
		this.email = data.email;
		Object.freeze(this);
	}

	static createEmpty(): EmailFormData {
		return new EmailFormData({ email: '' });
	}

	setEmail(email: string): this {
		return this.cloneWith({ email } as Partial<EmailFormArgs>);
	}
}

export default EmailFormData;
